/**
 * FunnelCard (KAN-737)
 *
 * Dashboard block "Воронка" over the whole organization.
 * Data: GET /api/v1/analytics/funnel/stages/?period=1d|7d|30d|all&channel=outreach|calls|all.
 * The block itself (tabs, legend, rows) is the shared FunnelStagesCard (KAN-744).
 */
import { funnelApi } from '@/services/api/funnel'
import { FUNNEL_STAGES_QUERY_KEY } from '@/services/api/queryKeys'
import { FunnelStagesCard } from './FunnelStagesCard'

export function FunnelCard() {
  return (
    <FunnelStagesCard
      title="Воронка"
      queryKey={FUNNEL_STAGES_QUERY_KEY}
      load={(period, channel) => funnelApi.getStageStats(period, channel)}
    />
  )
}
